// extracted by mini-css-extract-plugin
module.exports = {"clampedNote":"ClampedNote_clampedNote__2vmGD","clamped":"ClampedNote_clamped__2S-VN","expandToggle":"ClampedNote_expandToggle__CswY_"};